import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import TourOutOfSpins from './TournamentOutOfSpins';
import { openTourLobby } from '../../../../store/actionCreators/tournaments';

const TournamentFinished = ({ data: {data, onLobby}, onClose }) => {
  const dispatch = useDispatch();
  const onConfirm = ((tourId) => {
    dispatch(openTourLobby(data.tournamentId));
    onLobby();
    onClose();
  });
  return (
    <TourOutOfSpins data={data} isFinish={true} onClose={onClose} onConfirm={onConfirm} />
  )
}

export default TournamentFinished;